import paintIcon from "../../../../assets/images/paint_old-0.png";
import msie1 from "../../../../assets/images/msie1-1.png";
import computerExplorer from "../../../../assets/images/computer_explorer-3.png";
import recycleBinIcon from "../../../../assets/images/recycle_bin_full-3.png";
import RecycleBin from "../RecycleBin/RecycleBin";
import MyComputer from "../MyComputer/MyComputer";
import { DesktopApp, GAME_APPS } from "./gameApps";

export type { DesktopApp } from "./gameApps";
export { useOpenApp } from "./gameApps";

const InternetExplorerWindow = () => {
  return <div>Internet Explorer Content</div>;
};

const MyPortfolio = () => {
  return <div>Portfolio Content</div>;
};

// Shared by the desktop icons and the Start menu
export const DESKTOP_APPS: DesktopApp[] = [
  {
    iconSrc: msie1,
    name: "Internet Explorer",
    component: InternetExplorerWindow,
  },
  {
    iconSrc: computerExplorer,
    name: "Computer",
    component: MyComputer,
  },
  {
    iconSrc: recycleBinIcon,
    name: "Recycle Bin",
    component: RecycleBin,
  },
  {
    iconSrc: paintIcon,
    name: "Portfolio",
    component: MyPortfolio,
  },
  ...GAME_APPS,
];
